export default __webpack_public_path__ + "static/media/Group.6de19470.svg";